var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning"},[_c('div',{staticClass:"warning-content"},[_vm._v(" 缺少血氧数据，仅供参考，请结合临床！ ")]),_c('img',{staticClass:"warning-close",attrs:{"src":require("@imgs/warning_close.png")},on:{"click":_vm.onCloseClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }